import { AVATAR_URL } from "@/components/avatar";

export const HeroSection = () => {
  return (
    <div
      data-testid="hero-section"
      className="flex flex-col items-center sm:items-start text-center sm:text-left pt-16 sm:pt-24 pb-8"
    >
      <div className="relative mb-6">
        <img
          data-testid="hero-avatar"
          src={AVATAR_URL}
          alt="Thamelnesan"
          className="h-24 w-24 rounded-full object-cover border-2 border-[#0cb0b5] shadow-[0_0_28px_rgba(12,176,181,0.45)]"
        />
        <span className="absolute bottom-1.5 right-1.5 h-4 w-4 rounded-full bg-[#f5a524] border-2 border-[#09101a]" />
      </div>

      <div
        data-testid="status-badge"
        className="mb-5 flex items-center gap-2 rounded-full border border-[#0cb0b5]/30 bg-[#0cb0b5]/10 px-3 py-1"
      >
        <span className="text-xs font-semibold tracking-widest uppercase text-[#0cb0b5]">
          nesan.ai
        </span>
      </div>

      <h1
        data-testid="hero-name"
        className="font-heading text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-white"
      >
        Thamelnesan a.k.a Nesan
      </h1>
      <p
        data-testid="hero-tagline"
        className="font-heading text-xl sm:text-2xl text-[#0cb0b5] font-semibold tracking-tight mt-2"
      >
        Not around? Talk to me.
      </p>
      <p
        data-testid="hero-intro"
        className="text-base sm:text-lg text-slate-400 mt-4 max-w-2xl leading-relaxed"
      >
        I am his AI equivalent, enriched with his skills — ask me anything
        about a product idea, a messy PM problem, or a roadmap, or in general
        about life and experiences.
      </p>
    </div>
  );
};
